// import window.localStorage from 'js-cookie'
import { siteTokenKey } from '@/settings'

/**
 * 获取本地Token
 * @author LiQingSong
 */
export function getToken() {
  return localStorage.getItem(siteTokenKey)
}

/**
 * 设置存储Token
 * @author LiQingSong
 */
export function setToken(token) {
  return localStorage.setItem(siteTokenKey, token)
}

/**
 * 移除本地Token
 * @author LiQingSong
 */
export function removeToken() {
  return localStorage.removeItem(siteTokenKey)
}

/**
 * 获取本地用户信息
 */
export function getCompanyId() {
  return localStorage.getItem('user/companyId')
}

/**
 * 设置存储用户信息
 */
export function setCompanyId(id) {
  return localStorage.setItem('user/companyId', id)
}

/**
 * 获取本地用户信息
 */
export function getName() {
  return localStorage.getItem('user/name')
}

/**
 * 设置存储用户信息
 */
export function setName(id) {
  return localStorage.setItem('user/name', id)
}

/**
 * 获取用户自定义标题
 */
export async function getLogo() {
  let data = await window.localStorage.getItem('user/logo')
  return JSON.parse(data)
}

/**
 * 设置存储用户自定义标题
 */
export function setLogo(data) {
  return localStorage.setItem('user/logo', JSON.stringify(data))
}
